import AccountClarificationText from './AccountClarificationText'
export default AccountClarificationText;